import PropTypes from 'prop-types';
import React from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';

import config from '../../config';
import KeyGoForm from '../../records/customer/KeyGoForm';
import { translate as t } from '../../lib/I18n';

import CardDetails from '../payment/CardDetails';
import BillingAddress from '../payment/BillingAddress';
import Icon from '../general/Icon';
import CollectionStation from './smartcard/keyGoRegistration/CollectionStation';
import FormattedHTMLMessage from '../general/FormattedHTMLMessage';
import { TermsAndConditionsLink } from '../customer/SignupTAndCs';

const SmartcardPayment = ({ form, validation, visited, onChange, onAddressSelected, isUpdate, collectionLocationRequired }) => (
    <div className="payment-form keygo-card-details">
        <p>
            <Row>
                <Col md={7} lg={8} className="margin-bottom--sm">
                    <FormattedHTMLMessage
                        message="account.smartcard.keygo.cardTypes"
                        keygobrand={
                            <FormattedHTMLMessage message="account.smartcard.text.keygo" />
                        }
                    />
                </Col>
                <Col md={5} lg={4}>
                    <ul className="card-type-list text-center">
                        <li className="card-type--visa">
                            <span className="sr-only">{t('payment.cardType.visa')}</span>
                        </li>
                        <li className="card-type--mastercard">
                            <span className="sr-only">{t('payment.cardType.mastercard')}</span>
                        </li>
                        <li className="card-type--amex">
                            <span className="sr-only">{t('payment.cardType.amex')}</span>
                        </li>
                    </ul>
                </Col>
            </Row>
        </p>

        {isUpdate && (
            <h4 className="text-weight--normal text-primary">
                {t('account.smartcard.keygo.updatePayment')}
            </h4>
        )}

        <FormattedHTMLMessage
            message={`account.smartcard.keygo.details.${isUpdate ? 'reminder' : '1'}`}
            splitParagraphs
        />
        <FormattedHTMLMessage
            message="account.smartcard.keygo.details.2"
            tagName="ul"
            className="list-styled"
            splitParagraphs
            paragraphTagName="li"
        />

        <div className="alert-required margin-top">
            <Icon icon="mandatory" />
            <p>{t('required.fields')}</p>
        </div>

        {collectionLocationRequired && (
            <React.Fragment>
                <br />
                <CollectionStation
                    form={form}
                    validation={validation}
                    visited={visited}
                    onChange={onChange}
                    isKeyGo
                    required
                />
            </React.Fragment>
        )}

        <h3 className="payment__section-header">{t('account.smartcard.keygo.cardDetails')}</h3>

        <CardDetails
            form={form}
            validation={validation}
            visited={visited}
            onChange={onChange}
        />

        <BillingAddress
            className="border--bottom"
            form={form}
            validation={validation}
            visited={visited}
            onChange={onChange}
            onAddressSelected={onAddressSelected}
            alwaysShowAddressFields={visited}
            outsideLabel
        />

        <FormattedHTMLMessage
            message="account.smartcard.keygo.byContinuingYouAccept"
            termsAndConditions={
                <TermsAndConditionsLink
                    message={ t('form.keyGoTermsAndConditions') }
                    url={ config.get('keyGoTermsAndConditionsUrl') }
                />
            }
        />
    </div>
);


SmartcardPayment.propTypes = {
    form: PropTypes.instanceOf(KeyGoForm).isRequired,
    validation: PropTypes.object.isRequired,
    visited: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onAddressSelected: PropTypes.func.isRequired,
    isUpdate: PropTypes.bool,
    collectionLocationRequired: PropTypes.bool,
};

SmartcardPayment.defaultProps = {
    visited: false,
    isUpdate: false,
    collectionLocationRequired: false,
};


export default SmartcardPayment;



// WEBPACK FOOTER //
// ./src/components/account/SmartcardPayment.js